module.exports = __webpack_public_path__ + "static/why-ati__hero.6d768ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/why-ati__hero.jpg
// module id = 539
// module chunks = 144990353498473